import styled, { css } from 'styled-components'
import { defaultTransition } from '../../../theme'
import { Box } from '../../../shared_components/UI/Box'

export const Table = styled.table`
  width: 100%;
`

export const TableHeader = styled.th<{
  themeColor?: boolean
  textAlign?: string
}>`
  text-align: ${({ textAlign }) => textAlign || 'left'};
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  line-height: 12px;
  color: #fff;
`

export const CenterAlignedTableHeader = styled(TableHeader)`
  text-align: center;
`

export const Column = styled.col<{ columnWidth: string }>`
  width: ${({ columnWidth }) => columnWidth};
`

export const TableRow = styled.tr<{ showBorder: boolean; isVisible?: boolean }>`
  border-bottom: ${({ showBorder }) =>
    showBorder ? '1px solid rgba(255, 255, 255, 0.15)' : null};
  ${defaultTransition}

  opacity: 0;
  transform: translateX(100px);

  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(0);
      opacity: 1;
    `}
`

export const TableDivision = styled.td<{
  bold?: boolean
  highlight?: boolean
  textAlign?: string
}>`
  padding: 12px 0;
  ${({ bold }) =>
    bold &&
    css`
      font-weight: 700;
    `};
  ${({ theme, highlight }) =>
    highlight &&
    css`
      font-weight: 700;
      color: ${theme.colors.brandPrimary};
    `}
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `};
`

export const CenterAlignedTableDivision = styled(TableDivision)`
  text-align: center;
`

export const TableDivider = styled.div`
  width: 100%;
  height: 1px;

  // color: #fff;
  // background-color: #fff;
  opacity: 0.5;

  background-image: linear-gradient(
    to right,
    white 33%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 24px 1px;
  background-repeat: repeat-x;
`

export const You = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brandPrimary};
  opacity: 0.2;
`

export const LeaderboardBox = styled(Box)`
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(3, 11, 17, 0.9);
`
